"use strict";

var _classCallCheck = require("/Users/jonathanallenberg/projects/boxtronik/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/jonathanallenberg/projects/boxtronik/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/createClass");

var _defineProperty = require("/Users/jonathanallenberg/projects/boxtronik/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/defineProperty");

var _regeneratorRuntime = require("/Users/jonathanallenberg/projects/boxtronik/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/regenerator");

require("regenerator-runtime/runtime");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __asyncValues = this && this.__asyncValues || function (o) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var m = o[Symbol.asyncIterator],
      i;
  return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () {
    return this;
  }, i);

  function verb(n) {
    i[n] = o[n] && function (v) {
      return new Promise(function (resolve, reject) {
        v = o[n](v), settle(resolve, reject, v.done, v.value);
      });
    };
  }

  function settle(resolve, reject, d, v) {
    Promise.resolve(v).then(function (v) {
      resolve({
        value: v,
        done: d
      });
    }, reject);
  }
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BucketsGrpcClient = exports.bucketsArchiveWatch = exports.bucketsArchiveInfo = exports.bucketsArchiveStatus = exports.bucketsArchive = exports.bucketsSetDefaultArchiveConfig = exports.bucketsDefaultArchiveConfig = exports.bucketsPullPathAccessRoles = exports.bucketsPushPathAccessRoles = exports.bucketsRemovePath = exports.bucketsRemove = exports.bucketsPullIpfsPath = exports.bucketsPullPath = exports.bucketsSetPath = exports.bucketsPushPath = exports.bucketsListIpfsPath = exports.bucketsListPath = exports.bucketsList = exports.bucketsLinks = exports.bucketsRoot = exports.bucketsCreate = exports.StatusCode = exports.PathAccessRole = exports.AbortError = void 0;

var grpc_web_1 = require("@improbable-eng/grpc-web");

var buckets_pb_1 = require("@textile/buckets-grpc/buckets_pb");

var buckets_pb_service_1 = require("@textile/buckets-grpc/buckets_pb_service");

var context_1 = require("@textile/context");

var grpc_transport_1 = require("@textile/grpc-transport");

var cids_1 = __importDefault(require("cids"));

var event_iterator_1 = require("event-iterator");

var loglevel_1 = __importDefault(require("loglevel"));

var next_tick_1 = __importDefault(require("next-tick"));

var normalize_1 = require("./normalize"); // eslint-disable-next-line @typescript-eslint/no-var-requires


var block = require('it-block');

var logger = loglevel_1.default.getLogger('buckets-api');
exports.AbortError = new Error('aborted');
var PathAccessRole;

(function (PathAccessRole) {
  PathAccessRole[PathAccessRole["PATH_ACCESS_ROLE_UNSPECIFIED"] = 0] = "PATH_ACCESS_ROLE_UNSPECIFIED";
  PathAccessRole[PathAccessRole["PATH_ACCESS_ROLE_READER"] = 1] = "PATH_ACCESS_ROLE_READER";
  PathAccessRole[PathAccessRole["PATH_ACCESS_ROLE_WRITER"] = 2] = "PATH_ACCESS_ROLE_WRITER";
  PathAccessRole[PathAccessRole["PATH_ACCESS_ROLE_ADMIN"] = 3] = "PATH_ACCESS_ROLE_ADMIN";
})(PathAccessRole = exports.PathAccessRole || (exports.PathAccessRole = {}));

var fromProtoArchiveConfig = function fromProtoArchiveConfig(protoConfig) {
  var config = {
    addr: protoConfig.getAddr(),
    countryCodes: protoConfig.getCountryCodesList(),
    dealMinDuration: protoConfig.getDealMinDuration(),
    dealStartOffset: protoConfig.getDealStartOffset(),
    excludedMiners: protoConfig.getExcludedMinersList(),
    fastRetrieval: protoConfig.getFastRetrieval(),
    maxPrice: protoConfig.getMaxPrice(),
    repFactor: protoConfig.getRepFactor(),
    trustedMiners: protoConfig.getTrustedMinersList()
  };
  var renew = protoConfig.getRenew();

  if (renew) {
    config.renew = {
      enabled: renew.getEnabled(),
      threshold: renew.getThreshold()
    };
  }

  return config;
};

var toProtoArchiveConfig = function toProtoArchiveConfig(config) {
  var protoConfig = new buckets_pb_1.ArchiveConfig();
  protoConfig.setAddr(config.addr);
  protoConfig.setCountryCodesList(config.countryCodes);
  protoConfig.setDealMinDuration(config.dealMinDuration);
  protoConfig.setDealStartOffset(config.dealStartOffset);
  protoConfig.setExcludedMinersList(config.excludedMiners);
  protoConfig.setFastRetrieval(config.fastRetrieval);
  protoConfig.setMaxPrice(config.maxPrice);
  protoConfig.setRepFactor(config.repFactor);
  protoConfig.setTrustedMinersList(config.trustedMiners);

  if (config.renew) {
    var renew = new buckets_pb_1.ArchiveRenew();
    renew.setEnabled(config.renew.enabled);
    renew.setThreshold(config.renew.threshold);
    protoConfig.setRenew(renew);
  }

  return protoConfig;
};
/**
 * Archive status codes
 */


var StatusCode;

(function (StatusCode) {
  StatusCode[StatusCode["STATUS_UNSPECIFIED"] = 0] = "STATUS_UNSPECIFIED";
  StatusCode[StatusCode["STATUS_EXECUTING"] = 1] = "STATUS_EXECUTING";
  StatusCode[StatusCode["STATUS_FAILED"] = 2] = "STATUS_FAILED";
  StatusCode[StatusCode["STATUS_DONE"] = 3] = "STATUS_DONE";
  StatusCode[StatusCode["STATUS_CANCELED"] = 4] = "STATUS_CANCELED";
})(StatusCode = exports.StatusCode || (exports.StatusCode = {}));

var convertRootObject = function convertRootObject(root) {
  return {
    key: root.getKey(),
    name: root.getName(),
    path: root.getPath(),
    createdAt: root.getCreatedAt(),
    updatedAt: root.getUpdatedAt(),
    thread: root.getThread()
  };
};

var convertRootObjectNullable = function convertRootObjectNullable(root) {
  if (!root) return;
  return convertRootObject(root);
};

var convertMetadata = function convertMetadata(metadata) {
  if (!metadata) return;
  var roles = metadata.getRolesMap();
  var typedRoles = new Map();
  roles.forEach(function (entry, key) {
    return typedRoles.set(key, entry);
  });
  var response = {
    updatedAt: metadata.getUpdatedAt(),
    roles: typedRoles
  };
  return response;
};

var convertPathItem = function convertPathItem(item) {
  var list = item.getItemsList();
  return {
    cid: item.getCid(),
    name: item.getName(),
    path: item.getPath(),
    size: item.getSize(),
    isDir: item.getIsDir(),
    items: list ? list.map(convertPathItem) : [],
    count: item.getItemsCount(),
    metadata: convertMetadata(item.getMetadata())
  };
};

var convertPathItemNullable = function convertPathItemNullable(item) {
  if (!item) return;
  return convertPathItem(item);
};
/**
 * Creates a new bucket.
 * @public
 * @param name Human-readable bucket name. It is only meant to help identify a bucket in a UI and is not unique.
 * @param isPrivate encrypt the bucket contents (default `false`)
 * @param cid (optional) Bootstrap the bucket with a UnixFS Cid from the IPFS network
 * @example
 * Creates a Bucket called "app-name-files"
 * ```typescript
 * import { Buckets } from '@textile/hub'
 *
 * const create = async (buckets: Buckets) => {
 *     return buckets.create("app-name-files")
 * }
 * ```
 *
 * @internal
 */


function bucketsCreate(api, name) {
  var isPrivate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var cid = arguments.length > 3 ? arguments[3] : undefined;
  var ctx = arguments.length > 4 ? arguments[4] : undefined;
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var req, res, links;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            logger.debug('create request');
            req = new buckets_pb_1.CreateRequest();
            req.setName(name);

            if (cid) {
              req.setBootstrapCid(cid);
            }

            req.setPrivate(isPrivate);
            _context.next = 7;
            return api.unary(buckets_pb_service_1.APIService.Create, req, ctx);

          case 7:
            res = _context.sent;
            links = res.getLinks();
            return _context.abrupt("return", {
              seed: res.getSeed_asU8(),
              seedCid: res.getSeedCid(),
              root: convertRootObjectNullable(res.getRoot()),
              links: links ? links.toObject() : undefined
            });

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
}

exports.bucketsCreate = bucketsCreate;
/**
 * Returns the bucket root CID
 * @param key Unique (IPNS compatible) identifier key for a bucket.
 *
 * @internal
 */

function bucketsRoot(api, key, ctx) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var req, res;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            logger.debug('root request');
            req = new buckets_pb_1.RootRequest();
            req.setKey(key);
            _context2.next = 5;
            return api.unary(buckets_pb_service_1.APIService.Root, req, ctx);

          case 5:
            res = _context2.sent;
            return _context2.abrupt("return", convertRootObjectNullable(res.getRoot()));

          case 7:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
}

exports.bucketsRoot = bucketsRoot;
/**
 * Returns a list of bucket links.
 * @param key Unique (IPNS compatible) identifier key for a bucket.
 * @example
 * Generate the HTTP, IPNS, and IPFS links for a Bucket
 * ```typescript
 * import { Buckets } from '@textile/hub'
 *
 * const getLinks = async (buckets: Buckets) => {
 *    const links = buckets.links(bucketKey)
 *    return links.ipfs
 * }
 *
 * const getIpfs = async (buckets: Buckets) => {
 *    const links = buckets.links(bucketKey)
 *    return links.ipfs
 * }
 * ```
 *
 * @internal
 */

function bucketsLinks(api, key, path, ctx) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
    var req, res;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            logger.debug('link request');
            req = new buckets_pb_1.LinksRequest();
            req.setKey(key);
            req.setPath(path);
            _context3.next = 6;
            return api.unary(buckets_pb_service_1.APIService.Links, req, ctx);

          case 6:
            res = _context3.sent;
            return _context3.abrupt("return", res.toObject());

          case 8:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
}

exports.bucketsLinks = bucketsLinks;
/**
 * Returns a list of all bucket roots.
 * @example
 * Find an existing Bucket named "app-name-files"
 * ```typescript
 * import { Buckets } from '@textile/hub'
 *
 * const exists = async (buckets: Buckets) => {
 *     const roots = await buckets.list();
 *     return roots.find((bucket) => bucket.name ===  "app-name-files")
 * }
 * ```
 *
 * @internal
 */

function bucketsList(api, ctx) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
    var req, res, roots, map;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            logger.debug('list request');
            req = new buckets_pb_1.ListRequest();
            _context4.next = 4;
            return api.unary(buckets_pb_service_1.APIService.List, req, ctx);

          case 4:
            res = _context4.sent;
            roots = res.getRootsList();
            map = roots ? roots.map(function (m) {
              return m;
            }).map(function (m) {
              return convertRootObject(m);
            }) : [];
            return _context4.abrupt("return", map);

          case 8:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
}

exports.bucketsList = bucketsList;
/**
 * Returns information about a bucket path.
 * @param key Unique (IPNS compatible) identifier key for a bucket.
 * @param path A file/object (sub)-path within a bucket.
 *
 * @internal
 */

function bucketsListPath(api, key, path, ctx) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
    var req, res;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            logger.debug('list path request');
            req = new buckets_pb_1.ListPathRequest();
            req.setKey(key);
            req.setPath(path);
            _context5.next = 6;
            return api.unary(buckets_pb_service_1.APIService.ListPath, req, ctx);

          case 6:
            res = _context5.sent;
            return _context5.abrupt("return", {
              item: convertPathItemNullable(res.getItem()),
              root: convertRootObjectNullable(res.getRoot())
            });

          case 8:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
}

exports.bucketsListPath = bucketsListPath;
/**
 * listIpfsPath returns items at a particular path in a UnixFS path living in the IPFS network.
 * @param path UnixFS path
 *
 * @internal
 */

function bucketsListIpfsPath(api, path, ctx) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
    var req, res;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            logger.debug('list path request');
            req = new buckets_pb_1.ListIpfsPathRequest();
            req.setPath(path);
            _context6.next = 5;
            return api.unary(buckets_pb_service_1.APIService.ListIpfsPath, req, ctx);

          case 5:
            res = _context6.sent;
            return _context6.abrupt("return", convertPathItemNullable(res.getItem()));

          case 7:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
}

exports.bucketsListIpfsPath = bucketsListIpfsPath;
/**
 * Pushes a file to a bucket path.
 * @param key Unique (IPNS compatible) identifier key for a bucket.
 * @param path A file/object (sub)-path within a bucket.
 * @param input The input file/stream/object.
 * @param opts Options to control response stream.
 * @remarks
 * This will return the resolved path and the bucket's new root path.
 * @example
 * Push a file to the root of a bucket
 * ```typescript
 * import { Buckets } from '@textile/hub'
 *
 * const pushFile = async (content: string, bucketKey: string) => {
 *    const file = { path: '/index.html', content: Buffer.from(content) }
 *    return await buckets.pushPath(bucketKey!, 'index.html', file)
 * }
 * ```
 *
 * @internal
 */

function bucketsPushPath(api, key, path, input, opts, ctx) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
    var _this = this;

    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            return _context8.abrupt("return", new Promise(function (resolve, reject) {
              return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
                var e_1, _a, _b, _c, _d, _e, source, client, head, root, _head, req, metadata, process, _f, _g, chunk, buf, part;

                return _regeneratorRuntime.wrap(function _callee7$(_context7) {
                  while (1) {
                    switch (_context7.prev = _context7.next) {
                      case 0:
                        _context7.next = 2;
                        return normalize_1.normaliseInput(input).next();

                      case 2:
                        source = _context7.sent.value;
                        client = grpc_web_1.grpc.client(buckets_pb_service_1.APIService.PushPath, {
                          host: api.serviceHost,
                          transport: api.rpcOptions.transport,
                          debug: api.rpcOptions.debug
                        }); // Send a close event to the bucket api upon abort

                        if ((opts === null || opts === void 0 ? void 0 : opts.signal) !== undefined) {
                          opts.signal.addEventListener('abort', function () {
                            client.close();
                            return reject(exports.AbortError);
                          });
                        }

                        client.onMessage(function (message) {
                          var _a, _b, _c, _d; // Let's just make sure we haven't aborted this outside this function


                          if ((_a = opts === null || opts === void 0 ? void 0 : opts.signal) === null || _a === void 0 ? void 0 : _a.aborted) {
                            client.close();
                            return reject(exports.AbortError);
                          }

                          if (message.hasError()) {
                            // Reject on first error
                            return reject(new Error(message.getError()));
                          } else if (message.hasEvent()) {
                            var event = (_b = message.getEvent()) === null || _b === void 0 ? void 0 : _b.toObject();

                            if (event === null || event === void 0 ? void 0 : event.path) {
                              // @todo: Is there an standard library/tool for this step in JS?
                              var pth = event.path.startsWith('/ipfs/') ? event.path.split('/ipfs/')[1] : event.path;
                              var cid = new cids_1.default(pth);
                              var res = {
                                path: {
                                  path: "/ipfs/".concat(cid.toString()),
                                  cid: cid,
                                  root: cid,
                                  remainder: ''
                                },
                                root: (_d = (_c = event.root) === null || _c === void 0 ? void 0 : _c.path) !== null && _d !== void 0 ? _d : ''
                              };
                              return resolve(res);
                            } else if (opts === null || opts === void 0 ? void 0 : opts.progress) {
                              opts.progress(event === null || event === void 0 ? void 0 : event.bytes);
                            }
                          } else {
                            return reject(new Error('Invalid reply'));
                          }
                        });
                        client.onEnd(function (code, msg) {
                          if (code !== grpc_web_1.grpc.Code.OK) {
                            var message = msg ? msg : code.toString();
                            return reject(new Error(message));
                          } else {
                            return resolve();
                          }
                        });

                        if (!source) {
                          _context7.next = 64;
                          break;
                        }

                        head = new buckets_pb_1.PushPathRequest.Header();
                        head.setPath(source.path || path);
                        head.setKey(key); // Setting root here ensures pushes will error if root is out of date

                        root = '';

                        if (!(opts === null || opts === void 0 ? void 0 : opts.root)) {
                          _context7.next = 16;
                          break;
                        }

                        // If we explicitly received a root argument, use that
                        root = typeof opts.root === 'string' ? opts.root : opts.root.path;
                        _context7.next = 20;
                        break;

                      case 16:
                        _context7.next = 18;
                        return bucketsListPath(api, key, '', ctx);

                      case 18:
                        _head = _context7.sent;
                        root = (_c = (_b = _head.root) === null || _b === void 0 ? void 0 : _b.path) !== null && _c !== void 0 ? _c : ''; // Shouldn't ever be undefined here

                      case 20:
                        head.setRoot(root);
                        req = new buckets_pb_1.PushPathRequest();
                        req.setHeader(head);
                        metadata = Object.assign(Object.assign({}, api.context.toJSON()), ctx === null || ctx === void 0 ? void 0 : ctx.toJSON()); // Let's just make sure we haven't aborted this outside this function

                        if (!((_d = opts === null || opts === void 0 ? void 0 : opts.signal) === null || _d === void 0 ? void 0 : _d.aborted)) {
                          _context7.next = 26;
                          break;
                        }

                        return _context7.abrupt("return", reject(exports.AbortError));

                      case 26:
                        client.start(metadata);
                        client.send(req);

                        if (!source.content) {
                          _context7.next = 63;
                          break;
                        }

                        _context7.next = 31;
                        return block({
                          size: 32768,
                          noPad: true
                        });

                      case 31:
                        process = _context7.sent;
                        _context7.prev = 32;
                        _f = __asyncValues(process(source.content));

                      case 34:
                        _context7.next = 36;
                        return _f.next();

                      case 36:
                        _g = _context7.sent;

                        if (_g.done) {
                          _context7.next = 48;
                          break;
                        }

                        chunk = _g.value; // Let's just make sure we haven't aborted this outside this function

                        if (!((_e = opts === null || opts === void 0 ? void 0 : opts.signal) === null || _e === void 0 ? void 0 : _e.aborted)) {
                          _context7.next = 42;
                          break;
                        }

                        client.close();
                        return _context7.abrupt("return", reject(exports.AbortError));

                      case 42:
                        buf = chunk.slice();
                        part = new buckets_pb_1.PushPathRequest();
                        part.setChunk(buf);
                        client.send(part);

                      case 46:
                        _context7.next = 34;
                        break;

                      case 48:
                        _context7.next = 53;
                        break;

                      case 50:
                        _context7.prev = 50;
                        _context7.t0 = _context7["catch"](32);
                        e_1 = {
                          error: _context7.t0
                        };

                      case 53:
                        _context7.prev = 53;
                        _context7.prev = 54;

                        if (!(_g && !_g.done && (_a = _f.return))) {
                          _context7.next = 58;
                          break;
                        }

                        _context7.next = 58;
                        return _a.call(_f);

                      case 58:
                        _context7.prev = 58;

                        if (!e_1) {
                          _context7.next = 61;
                          break;
                        }

                        throw e_1.error;

                      case 61:
                        return _context7.finish(58);

                      case 62:
                        return _context7.finish(53);

                      case 63:
                        // We only need to finish send here if we actually started
                        client.finishSend();

                      case 64:
                      case "end":
                        return _context7.stop();
                    }
                  }
                }, _callee7, null, [[32, 50, 53, 63], [54,, 58, 62]]);
              }));
            }));

          case 1:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));
}

exports.bucketsPushPath = bucketsPushPath;
/**
 * Pushes a file to a bucket path.
 * @internal
 */

function bucketsSetPath(api, key, path, cid, ctx) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
    var request;
    return _regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            request = new buckets_pb_1.SetPathRequest();
            request.setKey(key);
            request.setPath(path);
            request.setCid(cid);
            _context9.next = 6;
            return api.unary(buckets_pb_service_1.APIService.SetPath, request, ctx);

          case 6:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9);
  }));
}

exports.bucketsSetPath = bucketsSetPath;
/**
 * Pulls the bucket path, returning the bytes of the given file.
 * @param key Unique (IPNS compatible) identifier key for a bucket.
 * @param path A file/object (sub)-path within a bucket.
 * @param opts Options to control response stream. Currently only supports a progress function.
 *
 * @internal
 */

function bucketsPullPath(api, key, path, opts, ctx) {
  var _this2 = this;

  var metadata = Object.assign(Object.assign({}, api.context.toJSON()), ctx === null || ctx === void 0 ? void 0 : ctx.toJSON());
  var request = new buckets_pb_1.PullPathRequest();
  request.setKey(key);
  request.setPath(path);
  var written = 0;
  var events = new event_iterator_1.EventIterator(function (_ref) {
    var push = _ref.push,
        stop = _ref.stop,
        fail = _ref.fail;
    var resp = grpc_web_1.grpc.invoke(buckets_pb_service_1.APIService.PullPath, {
      host: api.serviceHost,
      transport: api.rpcOptions.transport,
      debug: api.rpcOptions.debug,
      request: request,
      metadata: metadata,
      onMessage: function onMessage(res) {
        return __awaiter(_this2, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
          var chunk;
          return _regeneratorRuntime.wrap(function _callee10$(_context10) {
            while (1) {
              switch (_context10.prev = _context10.next) {
                case 0:
                  chunk = res.getChunk_asU8();
                  push(chunk);
                  written += chunk.byteLength;

                  if (opts === null || opts === void 0 ? void 0 : opts.progress) {
                    opts.progress(written);
                  }

                case 4:
                case "end":
                  return _context10.stop();
              }
            }
          }, _callee10);
        }));
      },
      onEnd: function onEnd(status, message, _trailers) {
        return __awaiter(_this2, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
          return _regeneratorRuntime.wrap(function _callee11$(_context11) {
            while (1) {
              switch (_context11.prev = _context11.next) {
                case 0:
                  if (status !== grpc_web_1.grpc.Code.OK) {
                    fail(new Error(message));
                  }

                  stop();

                case 2:
                case "end":
                  return _context11.stop();
              }
            }
          }, _callee11);
        }));
      }
    });
    return function () {
      return resp.close();
    };
  });
  var it = Object.assign(_defineProperty({}, Symbol.asyncIterator, function () {
    return this;
  }), events[Symbol.asyncIterator]());
  return it;
}

exports.bucketsPullPath = bucketsPullPath;
/**
 * pullIpfsPath pulls the path from a remote UnixFS dag, writing it to writer if it's a file.
 * @param path A file/object (sub)-path within a bucket.
 * @param opts Options to control response stream. Currently only supports a progress function.
 *
 * @internal
 */

function bucketsPullIpfsPath(api, path, opts, ctx) {
  var _this3 = this;

  var metadata = Object.assign(Object.assign({}, api.context.toJSON()), ctx === null || ctx === void 0 ? void 0 : ctx.toJSON());
  var request = new buckets_pb_1.PullIpfsPathRequest();
  request.setPath(path);
  var written = 0;
  var events = new event_iterator_1.EventIterator(function (_ref2) {
    var push = _ref2.push,
        stop = _ref2.stop,
        fail = _ref2.fail;
    var resp = grpc_web_1.grpc.invoke(buckets_pb_service_1.APIService.PullIpfsPath, {
      host: api.serviceHost,
      transport: api.rpcOptions.transport,
      debug: api.rpcOptions.debug,
      request: request,
      metadata: metadata,
      onMessage: function onMessage(res) {
        return __awaiter(_this3, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee12() {
          var chunk;
          return _regeneratorRuntime.wrap(function _callee12$(_context12) {
            while (1) {
              switch (_context12.prev = _context12.next) {
                case 0:
                  chunk = res.getChunk_asU8();
                  push(chunk);
                  written += chunk.byteLength;

                  if (opts === null || opts === void 0 ? void 0 : opts.progress) {
                    opts.progress(written);
                  }

                case 4:
                case "end":
                  return _context12.stop();
              }
            }
          }, _callee12);
        }));
      },
      onEnd: function onEnd(status, message, _trailers) {
        return __awaiter(_this3, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee13() {
          return _regeneratorRuntime.wrap(function _callee13$(_context13) {
            while (1) {
              switch (_context13.prev = _context13.next) {
                case 0:
                  if (status !== grpc_web_1.grpc.Code.OK) {
                    fail(new Error(message));
                  }

                  stop();

                case 2:
                case "end":
                  return _context13.stop();
              }
            }
          }, _callee13);
        }));
      }
    });
    return function () {
      return resp.close();
    };
  });
  var it = Object.assign(_defineProperty({}, Symbol.asyncIterator, function () {
    return this;
  }), events[Symbol.asyncIterator]());
  return it;
}

exports.bucketsPullIpfsPath = bucketsPullIpfsPath;
/**
 * Removes an entire bucket. Files and directories will be unpinned.
 * @param key Unique (IPNS compatible) identifier key for a bucket.
 *
 * @internal
 */

function bucketsRemove(api, key, ctx) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee14() {
    var req;
    return _regeneratorRuntime.wrap(function _callee14$(_context14) {
      while (1) {
        switch (_context14.prev = _context14.next) {
          case 0:
            logger.debug('remove request');
            req = new buckets_pb_1.RemoveRequest();
            req.setKey(key);
            _context14.next = 5;
            return api.unary(buckets_pb_service_1.APIService.Remove, req, ctx);

          case 5:
            return _context14.abrupt("return");

          case 6:
          case "end":
            return _context14.stop();
        }
      }
    }, _callee14);
  }));
}

exports.bucketsRemove = bucketsRemove;
/**
 * Returns information about a bucket path.
 * @param key Unique (IPNS compatible) identifier key for a bucket.
 * @param path A file/object (sub)-path within a bucket.
 * @param root optional to specify a root
 *
 * @internal
 */

function bucketsRemovePath(api, key, path, root, ctx) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee15() {
    var req;
    return _regeneratorRuntime.wrap(function _callee15$(_context15) {
      while (1) {
        switch (_context15.prev = _context15.next) {
          case 0:
            logger.debug('remove path request');
            req = new buckets_pb_1.RemovePathRequest();
            req.setKey(key);
            req.setPath(path);
            if (root) req.setRoot(root);
            _context15.next = 7;
            return api.unary(buckets_pb_service_1.APIService.RemovePath, req, ctx);

          case 7:
            return _context15.abrupt("return");

          case 8:
          case "end":
            return _context15.stop();
        }
      }
    }, _callee15);
  }));
}

exports.bucketsRemovePath = bucketsRemovePath;

function bucketsPushPathAccessRoles(api, key, path, roles, ctx) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee16() {
    var req;
    return _regeneratorRuntime.wrap(function _callee16$(_context16) {
      while (1) {
        switch (_context16.prev = _context16.next) {
          case 0:
            logger.debug('remove path request');
            req = new buckets_pb_1.PushPathAccessRolesRequest();
            req.setKey(key);
            req.setPath(path);
            roles.forEach(function (value, key) {
              return req.getRolesMap().set(key, value);
            });
            _context16.next = 7;
            return api.unary(buckets_pb_service_1.APIService.PushPathAccessRoles, req, ctx);

          case 7:
            return _context16.abrupt("return");

          case 8:
          case "end":
            return _context16.stop();
        }
      }
    }, _callee16);
  }));
}

exports.bucketsPushPathAccessRoles = bucketsPushPathAccessRoles;

function bucketsPullPathAccessRoles(api, key) {
  var path = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '/';
  var ctx = arguments.length > 3 ? arguments[3] : undefined;
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee17() {
    var req, response, roles, typedRoles;
    return _regeneratorRuntime.wrap(function _callee17$(_context17) {
      while (1) {
        switch (_context17.prev = _context17.next) {
          case 0:
            logger.debug('remove path request');
            req = new buckets_pb_1.PullPathAccessRolesRequest();
            req.setKey(key);
            req.setPath(path);
            _context17.next = 6;
            return api.unary(buckets_pb_service_1.APIService.PullPathAccessRoles, req, ctx);

          case 6:
            response = _context17.sent;
            roles = response.getRolesMap();
            typedRoles = new Map();
            roles.forEach(function (entry, key) {
              return typedRoles.set(key, entry);
            });
            return _context17.abrupt("return", typedRoles);

          case 11:
          case "end":
            return _context17.stop();
        }
      }
    }, _callee17);
  }));
}

exports.bucketsPullPathAccessRoles = bucketsPullPathAccessRoles;
/**
 * @internal
 */

function bucketsDefaultArchiveConfig(api, key, ctx) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee18() {
    var req, res, config;
    return _regeneratorRuntime.wrap(function _callee18$(_context18) {
      while (1) {
        switch (_context18.prev = _context18.next) {
          case 0:
            logger.debug('default archive config request');
            req = new buckets_pb_1.DefaultArchiveConfigRequest();
            req.setKey(key);
            _context18.next = 5;
            return api.unary(buckets_pb_service_1.APIService.DefaultArchiveConfig, req, ctx);

          case 5:
            res = _context18.sent;
            config = res.getArchiveConfig();

            if (config) {
              _context18.next = 9;
              break;
            }

            throw new Error('no archive config returned');

          case 9:
            return _context18.abrupt("return", fromProtoArchiveConfig(config));

          case 10:
          case "end":
            return _context18.stop();
        }
      }
    }, _callee18);
  }));
}

exports.bucketsDefaultArchiveConfig = bucketsDefaultArchiveConfig;
/**
 * @internal
 */

function bucketsSetDefaultArchiveConfig(api, key, config, ctx) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee19() {
    var req;
    return _regeneratorRuntime.wrap(function _callee19$(_context19) {
      while (1) {
        switch (_context19.prev = _context19.next) {
          case 0:
            logger.debug('set default archive config request');
            req = new buckets_pb_1.SetDefaultArchiveConfigRequest();
            req.setKey(key);
            req.setArchiveConfig(toProtoArchiveConfig(config));
            _context19.next = 6;
            return api.unary(buckets_pb_service_1.APIService.SetDefaultArchiveConfig, req, ctx);

          case 6:
            return _context19.abrupt("return");

          case 7:
          case "end":
            return _context19.stop();
        }
      }
    }, _callee19);
  }));
}

exports.bucketsSetDefaultArchiveConfig = bucketsSetDefaultArchiveConfig;
/**
 * archive creates a Filecoin bucket archive via Powergate.
 * @internal
 * @param key Unique (IPNS compatible) identifier key for a bucket.
 * @param options Options that control the behavior of the bucket archive
 */

function bucketsArchive(api, key, options, ctx) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee20() {
    var req;
    return _regeneratorRuntime.wrap(function _callee20$(_context20) {
      while (1) {
        switch (_context20.prev = _context20.next) {
          case 0:
            logger.debug('archive request');
            req = new buckets_pb_1.ArchiveRequest();
            req.setKey(key);

            if (options === null || options === void 0 ? void 0 : options.archiveConfig) {
              req.setArchiveConfig(toProtoArchiveConfig(options.archiveConfig));
            }

            _context20.next = 6;
            return api.unary(buckets_pb_service_1.APIService.Archive, req, ctx);

          case 6:
            return _context20.abrupt("return");

          case 7:
          case "end":
            return _context20.stop();
        }
      }
    }, _callee20);
  }));
}

exports.bucketsArchive = bucketsArchive;
/**
 * archiveStatus returns the status of a Filecoin bucket archive.
 * @internal
 * @param key Unique (IPNS compatible) identifier key for a bucket.
 */

function bucketsArchiveStatus(api, key, ctx) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee21() {
    var req, res;
    return _regeneratorRuntime.wrap(function _callee21$(_context21) {
      while (1) {
        switch (_context21.prev = _context21.next) {
          case 0:
            logger.debug('archive status request');
            req = new buckets_pb_1.ArchiveStatusRequest();
            req.setKey(key);
            _context21.next = 5;
            return api.unary(buckets_pb_service_1.APIService.ArchiveStatus, req, ctx);

          case 5:
            res = _context21.sent;
            return _context21.abrupt("return", {
              key: res.getKey(),
              status: res.getStatus(),
              failedMsg: res.getFailedMsg()
            });

          case 7:
          case "end":
            return _context21.stop();
        }
      }
    }, _callee21);
  }));
}

exports.bucketsArchiveStatus = bucketsArchiveStatus;
/**
 * archiveInfo returns info about a Filecoin bucket archive.
 * @internal
 * @param key Unique (IPNS compatible) identifier key for a bucket.
 */

function bucketsArchiveInfo(api, key, ctx) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee22() {
    var req, res, archive, deals;
    return _regeneratorRuntime.wrap(function _callee22$(_context22) {
      while (1) {
        switch (_context22.prev = _context22.next) {
          case 0:
            logger.debug('archive info request');
            req = new buckets_pb_1.ArchiveInfoRequest();
            req.setKey(key);
            _context22.next = 5;
            return api.unary(buckets_pb_service_1.APIService.ArchiveInfo, req, ctx);

          case 5:
            res = _context22.sent;
            archive = res.getArchive();
            deals = archive ? archive.getDealsList() : [];
            return _context22.abrupt("return", {
              key: res.getKey(),
              cid: archive ? archive.getCid() : undefined,
              deals: deals.map(function (d) {
                return {
                  proposalCid: d.getProposalCid(),
                  miner: d.getMiner()
                };
              })
            });

          case 9:
          case "end":
            return _context22.stop();
        }
      }
    }, _callee22);
  }));
}

exports.bucketsArchiveInfo = bucketsArchiveInfo;
/**
 * archiveWatch watches status events from a Filecoin bucket archive.
 * @internal
 * @param key Unique (IPNS compatible) identifier key for a bucket.
 */

function bucketsArchiveWatch(api, key, callback, ctx) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee23() {
    var req, metadata, res;
    return _regeneratorRuntime.wrap(function _callee23$(_context23) {
      while (1) {
        switch (_context23.prev = _context23.next) {
          case 0:
            logger.debug('archive watch request');
            req = new buckets_pb_1.ArchiveWatchRequest();
            req.setKey(key);
            metadata = Object.assign(Object.assign({}, api.context.toJSON()), ctx === null || ctx === void 0 ? void 0 : ctx.toJSON());
            res = grpc_web_1.grpc.invoke(buckets_pb_service_1.APIService.ArchiveWatch, {
              host: api.context.host,
              request: req,
              metadata: metadata,
              onMessage: function onMessage(rec) {
                var response = {
                  id: rec.getJsPbMessageId(),
                  msg: rec.getMsg()
                };
                next_tick_1.default(function () {
                  return callback(response);
                });
              },
              onEnd: function onEnd(status, message, _trailers) {
                if (status !== grpc_web_1.grpc.Code.OK) {
                  return callback(undefined, new Error(message));
                }

                callback();
              }
            });
            return _context23.abrupt("return", res.close.bind(res));

          case 6:
          case "end":
            return _context23.stop();
        }
      }
    }, _callee23);
  }));
}

exports.bucketsArchiveWatch = bucketsArchiveWatch;
/**
 * Raw API connected needed by Buckets CI code (compile friendly)
 * see more https://github.com/textileio/github-action-buckets
 */

var BucketsGrpcClient = /*#__PURE__*/function () {
  /**
   * Creates a new gRPC client instance for accessing the Textile Buckets API.
   * @param context The context to use for interacting with the APIs. Can be modified later.
   */
  function BucketsGrpcClient() {
    var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new context_1.Context();
    var debug = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    _classCallCheck(this, BucketsGrpcClient);

    this.context = context;
    this.serviceHost = context.host;
    this.rpcOptions = {
      transport: grpc_transport_1.WebsocketTransport(),
      debug: debug
    };
  }

  _createClass(BucketsGrpcClient, [{
    key: "unary",
    value: function unary(methodDescriptor, req, ctx) {
      var _this4 = this;

      return new Promise(function (resolve, reject) {
        var metadata = Object.assign(Object.assign({}, _this4.context.toJSON()), ctx === null || ctx === void 0 ? void 0 : ctx.toJSON());
        grpc_web_1.grpc.unary(methodDescriptor, {
          request: req,
          host: _this4.serviceHost,
          transport: _this4.rpcOptions.transport,
          debug: _this4.rpcOptions.debug,
          metadata: metadata,
          onEnd: function onEnd(res) {
            var status = res.status,
                statusMessage = res.statusMessage,
                message = res.message;

            if (status === grpc_web_1.grpc.Code.OK) {
              if (message) {
                resolve(message);
              } else {
                resolve();
              }
            } else {
              reject(new Error(statusMessage));
            }
          }
        });
      });
    }
  }]);

  return BucketsGrpcClient;
}();

exports.BucketsGrpcClient = BucketsGrpcClient;